// ABOUTME: Bar chart icon for statistics section in sidebar and headers
// ABOUTME: Used for navigation to statistics pages and as visual indicator

import type { FC } from "react"

interface ChartBarIconProps {
  className?: string
  size?: number
  color?: string
}

export const ChartBarIcon: FC<ChartBarIconProps> = ({ className, size = 16, color = "currentColor" }) => {
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M2 11a1 1 0 011-1h2a1 1 0 011 1v5a1 1 0 01-1 1H3a1 1 0 01-1-1v-5zm6-4a1 1 0 011-1h2a1 1 0 011 1v9a1 1 0 01-1 1H9a1 1 0 01-1-1V7zm6-3a1 1 0 011-1h2a1 1 0 011 1v12a1 1 0 01-1 1h-2a1 1 0 01-1-1V4z" />
    </svg>
  )
}
